var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"navbar-burger",class:{'is-active': _vm.mobileVisible},on:{"click":_vm.toggle}},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d93fc19a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontend/menu/MobileToggle.vue
// module id = 1146
// module chunks = 0